import axios from 'axios';
import api from './ApiAuthService';

export default class Tips {
  static async postComentario(dados: any, url: '/posts/tips/comment') {
    try {
      const response = await api.post(url, dados);
      return response.data;
    } catch (error) {
      throw error;
    }

  }

  static async postComentarioResposta(dados: any, url: '/posts/tips/answer') {
    try {
      const response = await api.post(url, dados);
      return response.data;
    } catch (error) {
      throw error;
    }

  }
}